export type BatteryWarningLevel = "critical" | "low" | "ok" | "good" | "full" | "unknown";

export type BatteryIndicatorToWarningLevelConversion = (
    indicatorValue: number,
    information: {
        temperature: number;
    },
) => BatteryWarningLevel;

export type BatteryIndicatorToLabelConversion = (indicatorValue: number) => string;

export const sproutBatteryWarningConversion: BatteryIndicatorToWarningLevelConversion = (voltage) => {
    if (voltage === undefined || voltage < 1 || voltage > 11) {
        return "unknown";
    }
    if (voltage > 6) {
        if (voltage < 7.25) {
            return "critical";
        }
        if (voltage < 8) {
            return "ok";
        }
        if (voltage < 8.2) {
            return "good";
        }
        return "full";
    }
    if (voltage < 1.5 * 2) {
        return "critical";
    }
    if (voltage < 1.55 * 2) {
        return "ok";
    }
    if (voltage < 1.6 * 2) {
        return "good";
    }
    return "full";
};

export const sproutBatteryLabelConversion: BatteryIndicatorToLabelConversion = (voltage) => {
    if (voltage === undefined || voltage < 1 || voltage > 11) {
        return "N/A";
    }
    return (voltage || 0).toString() + "V";
};

export const saplingBatteryWarningConversion: BatteryIndicatorToWarningLevelConversion = (percentage) => {
    if (percentage === undefined || percentage < 0) {
        return "unknown";
    }
    if (percentage < 0.07) {
        return "critical";
    } else if (percentage < 0.3) {
        return "ok";
    } else if (percentage < 0.7) {
        return "good";
    }
    return "full";
};

/** @deprecated Never called — sap_* device types are RETIRED and batteryIndicatorToSpecificLabel has no call sites. */
export const saplingBatteryLabelConversion: BatteryIndicatorToLabelConversion = (percentage) => {
    if (percentage === undefined || percentage < 0) {
        return "N/A";
    }
    return Math.round((percentage || 0) * 100).toString() + "%";
};
